// extracted by mini-css-extract-plugin
module.exports = {"formItem":"FormItem_formItem__1vOJd","label":"FormItem_label__2MlRM"};